import { AnyAction } from "redux";
import {
  APPLY_DSP_CODE,
  CHANGE_STATUS_IS_HAVE_SETUP_SERVICE,
  DECREASE_INCREASE_CART_PRODUCTS,
  FETCH_CART_PRODUCTS,
  FETCH_CART_PRODUCTS_ERROR,
  FETCH_CART_PRODUCTS_SUCCESS,
  // FETCH_CART_WITH_DSP_CODE_ERROR,
  // FETCH_CART_WITH_DSP_CODE_SUCCESS,
  REMOVE_CART_PRODUCTS,
  REMOVE_DSP_CODE,
  UPDATE_CART_PRODUCTS,
  USE_PROMOTION_CODE,
  HAS_CROSS_SELL_ADDED,
  RESET_ERROR_CART,
} from "redux/actions/products/cart";

const defaultState = {
  data: {},
  error: null,
  loading: false,
  loaded: false,
  code: [],
  checkAction: null,
  dspCode: null,
  hasCrossSellAdded: false
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case FETCH_CART_PRODUCTS:
    case DECREASE_INCREASE_CART_PRODUCTS:
    case USE_PROMOTION_CODE:
    case APPLY_DSP_CODE:
    case REMOVE_DSP_CODE:
    case REMOVE_CART_PRODUCTS:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_CART_PRODUCTS:
      return {
        ...state,
        error: null,
        loading: true,
        code: [],
        checkAction: null,
      };
    case FETCH_CART_PRODUCTS_SUCCESS:
      return {
        ...state,
        data: action.cart,
        error: null,
        loading: false,
        loaded: true,
        code:
          Object.keys(action.cart).length === 0 || action.code?.length === 0
            ? []
            : action.code?.length > 0 && action.cart.total_promotion > 0
              ? action.code
              : state.code,
        dspCode:
          Object.keys(action.cart).length === 0 || action.dspCode === ""
            ? null
            : action.dspCode || state.dspCode,
        checkAction: action.checkAction ? action.checkAction : null,
      };
    case FETCH_CART_PRODUCTS_ERROR:
      const prevItemId = localStorage.getItem("prevcartitemId");
      switch (action?.error?.response?.data?.errors[0]?.code) {
        case "599":
          if (prevItemId) {
            const prevItem: LocalPrevCartItem = JSON.parse(prevItemId);
            const updateItem: LocalPrevCartItem = {
              ...prevItem,
              isError: true,
            };
            localStorage.setItem("prevcartitemId", JSON.stringify(updateItem));
          }
          break;
        default:
          break;
      }

      let codeRes: Array<any> = state.code;
      if (action?.error?.response?.data?.errors[0]?.code === "518") {
        codeRes = [];
      } else if (action?.error?.response?.data?.errors[0]?.code === "600") {
        codeRes = ['600'];
      }

      return {
        ...state,
        error: action.error,
        loading: false,
        loaded: true,
        code: codeRes,
        checkAction: action.checkAction ? action.checkAction : null,
      };
    case CHANGE_STATUS_IS_HAVE_SETUP_SERVICE:
      return {
        ...state,
        error: null,
        code: state.code,
        checkAction: null,
      };
    case HAS_CROSS_SELL_ADDED:
      return {
        ...state,
        error: null,
        hasCrossSellAdded: action.hasCrossSellAdded
      };
    case RESET_ERROR_CART:
      return {
        ...state,
        error: null,
        code: [],
      };
    default:
      return state;
  }
};
